export const stickerMargin = 10;
